export default __webpack_public_path__ + "static/media/2091-00.2e768048.jpg";